import { useFormikContext } from 'formik'

import { FinancialProfile } from '@/reducers/auth/userReducer'
import { Form } from '@/ui'
import {
  FILING_STATUS_COPY,
  FILING_STATUSES,
  FilingStatusOptions,
} from '@/features/taxes/taxConstants'

// TODO: Migrate to V2
import {
  FormikLabelError,
  getFieldName,
  makeReqBoolSchema,
  makeReqStringSchema,
} from '@/componentsV1/BaseComponents'
interface FilingStatusValues {
  filingStatusSame: boolean | undefined
  filingStatus: FILING_STATUSES | undefined
}

export const FilingStatusSubForm = ({ fp }: { fp?: FinancialProfile }) => {
  const { values } = useFormikContext<FilingStatusValues>()

  if (!fp) {
    return null
  }
  return fp?.filingStatus ? (
    <>
      <FormikLabelError
        name={getFieldName<typeof values>('filingStatusSame')}
        required
        label={
          <>
            Are you still filing as{' '}
            <b>{FILING_STATUS_COPY[fp.filingStatus]?.title}</b>?
          </>
        }
        description="If this has changed, select No."
        schema={makeReqBoolSchema()}
      />

      <div className="flex flex-wrap gap-4 mt-2">
        <Form.BooleanRadioGroup
          name={getFieldName<typeof values>('filingStatusSame')}
        />
      </div>

      {values.filingStatusSame === false && (
        <Form.Select
          className="w-full mt-4"
          name={getFieldName<typeof values>('filingStatus')}
          options={FilingStatusOptions}
          label="What is your new filing status?"
          required
          schema={makeReqStringSchema()}
        />
      )}
    </>
  ) : (
    <Form.Select
      className="w-full"
      name={getFieldName<typeof values>('filingStatus')}
      options={FilingStatusOptions}
      label="What is your filing status?"
      required
      schema={makeReqStringSchema()}
    />
  )
}
